export default {
  label: {
    color: '#993366',
  },
  base03: '#AAAAAA',
  base0B: '#333333',
  base0D: '#333333',
};
